import * as SEARCH_ACTION from 'js/constant/action/search'
import { createAction } from 'redux-actions'

const updateAdvancedSearchModal = createAction(SEARCH_ACTION.UPDATE_ADVANCED_SEARCH_MODAL)

export const openAdvancedSearchModal =
    (bool) =>
      async (dispatch, getState, { search }) => {
        dispatch(updateAdvancedSearchModal(bool))
      }
